module.exports = __webpack_public_path__ + "static/media/rajat_-PJOszOsi.3403045e.jpg";